export const translations = {
  en: {
    nav: {
      features: 'Features',
      howItWorks: 'How It Works',
      pricing: 'Pricing',
      download: 'Download'
    },
    header: {
      features: 'Features',
      howItWorks: 'How It Works',
      testimonials: 'Testimonials',
      pricing: 'Pricing',
      download: 'Download'
    },
    hero: {
      title: 'Track Calories with AI-Powered Photo Recognition',
      description: '1cal.ai uses advanced AI to identify foods and track your nutrition from photos. Achieve your health goals with precision and ease.',
      appStore: 'App Store',
      appStoreSmall: 'Download on the',
      googlePlay: 'Google Play',
      googlePlaySmall: 'GET IT ON'
    },
    features: {
      title: 'Key Features',
      subtitle: 'Discover what makes 1cal.ai the smartest way to track your nutrition',
      items: [
        {
          title: 'AI Photo Recognition',
          description: 'Take a photo of your food and our AI instantly identifies calories, protein, fats, and carbs.'
        },
        {
          title: 'Nutrition Tracking',
          description: 'Monitor your daily intake of calories, protein, fats, and carbohydrates with beautiful visualizations.'
        },
        {
          title: 'Light & Dark Themes',
          description: 'Enjoy a comfortable experience with customizable light and dark themes for any environment.'
        },
        {
          title: 'Multilingual Support',
          description: 'Use the app in your preferred language with support for English, Russian, and more.'
        },
        {
          title: 'Meal History',
          description: 'Track your eating patterns over time with detailed meal history and analytics.'
        },
        {
          title: 'Goal Setting',
          description: 'Set personalized nutrition goals and track your progress with intuitive visualizations.'
        }
      ]
    },
    howItWorks: {
      title: 'How It Works',
      subtitle: 'Track your nutrition in three simple steps',
      steps: [
        {
          title: 'Take a Photo',
          description: 'Simply take a photo of your meal using the app\'s camera.'
        },
        {
          title: 'AI Analysis',
          description: 'Our advanced AI identifies the food and calculates nutritional values.'
        },
        {
          title: 'Track Progress',
          description: 'Monitor your daily intake and progress toward your nutrition goals.'
        }
      ]
    },
    showcase: {
      title: 'App Showcase',
      subtitle: 'See how 1cal.ai makes nutrition tracking effortless'
    },
    testimonials: {
      title: 'What Our Users Say',
      subtitle: 'Join thousands of satisfied users who have transformed their nutrition habits'
    },
    pricing: {
      title: 'Simple Pricing',
      subtitle: 'Choose the plan that fits your needs',
      chooseYourPlan: 'Choose Your Plan',
      monthly: 'Monthly',
      annual: 'Annual',
      free: 'Free',
      premium: 'Premium',
      perMonth: '/month',
      perYear: '/year',
      popular: 'Popular',
      discount: '63% off',
      downloadFree: 'Download Free',
      getPremium: 'Get Premium',
      monthlySubscribe: 'Subscribe Monthly',
      annualSubscribe: 'Subscribe Yearly',
      onlyPerMonth: 'Only {{price}}/month',
      freeTrial: 'Includes 3-day free trial',
      description: 'Get unlimited access to AI food recognition, detailed nutrition tracking, and personalized insights to help you achieve your health goals.',
      disclaimer: 'Prices are in USD. By subscribing, you agree to our',
      refundInfo: 'For more information about our refund policy, please visit our',
      features: {
        basicRecognition: 'Basic food recognition',
        advancedRecognition: 'Advanced AI food recognition',
        calorieTracking: 'Calorie tracking',
        detailedTracking: 'Detailed nutrition tracking',
        dailySummary: 'Daily nutrition summary',
        unlimitedLogs: 'Unlimited meal logs',
        limitedLogs: '5 meal logs per day',
        reports: 'Weekly & monthly reports',
        insights: 'Advanced nutrition insights',
        personalizedInsights: 'Personalized nutrition insights',
        recommendations: 'Meal recommendations',
        smartRecommendations: 'Smart meal recommendations'
      }
    },
    download: {
      title: 'Download 1cal.ai Today',
      description: 'Start your journey to better nutrition with our AI-powered calorie tracking app. Available on iOS and Android.'
    },
    faq: {
      title: 'Frequently Asked Questions',
      subtitle: 'Find answers to common questions about 1cal.ai',
      items: [
        {
          question: 'How accurate is the AI food recognition?',
          answer: 'Our AI food recognition technology is powered by state-of-the-art machine learning models and has an accuracy rate of over 95% for common foods. The system continuously improves as more users utilize the app.'
        },
        {
          question: 'Which languages are supported?',
          answer: '1cal.ai currently supports English, Russian, Spanish, French, German, Chinese, Japanese, and Korean. We are constantly working on adding more languages to make our app accessible to users worldwide.'
        },
        {
          question: 'Can I track custom meals?',
          answer: 'Yes! In addition to AI recognition, you can manually add custom meals and save them for future use. This is especially useful for homemade recipes or unique dishes.'
        },
        {
          question: 'How do I cancel my premium subscription?',
          answer: 'You can cancel your premium subscription at any time through your account settings in the app or through your app store subscription management. Cancellation will take effect at the end of your current billing period.'
        }
      ]
    },
    footer: {
      description: 'AI-powered calorie tracking app that makes nutrition monitoring simple and accurate.',
      quickLinks: 'Quick Links',
      support: 'Support',
      helpCenter: 'Help Center',
      privacyPolicy: 'Privacy Policy',
      termsOfService: 'Terms of Service',
      contact: 'Contact Us',
      stayUpdated: 'Stay Updated',
      newsletterText: 'Subscribe to our newsletter for the latest updates and features.',
      subscribe: 'Subscribe',
      emailPlaceholder: 'Your Email',
      copyright: '© 2025 1cal.ai. All rights reserved.',
      privacy: 'Privacy Policy',
      terms: 'Terms of Service',
      subscription: 'Subscription Terms',
      refund: 'Refund Policy',
      pricing: 'Pricing',
      rights: 'All rights reserved.',
      deleteAccount: 'If you want to delete your account, please contact us by email'
    },
    comingSoon: {
      appStore: {
        title: 'App Store Coming Soon',
        description1: 'Our iOS application is currently under development and will be available on App Store soon. We\'re working hard to provide the best calorie tracking experience for all users.',
        description2: 'For now, our app is available on Google Play. You can also subscribe to our newsletter to get notified when the iOS version launches.'
      },
      googlePlay: {
        title: 'Google Play Coming Soon',
        description1: 'Our Android application is currently under development and will be available on Google Play Store soon. We\'re working hard to provide the best calorie tracking experience for all users.',
        description2: 'For now, our app is available on iOS App Store. You can also subscribe to our newsletter to get notified when the Android version launches.'
      },
      backToHome: 'Back to Home'
    }
  },
  ru: {
    nav: {
      features: 'Возможности',
      howItWorks: 'Как это работает',
      pricing: 'Цены',
      download: 'Скачать'
    },
    header: {
      features: 'Возможности',
      howItWorks: 'Как это работает',
      testimonials: 'Отзывы',
      pricing: 'Цены',
      download: 'Скачать'
    },
    hero: {
      title: 'Отслеживайте калории с помощью ИИ-распознавания фото',
      description: '1cal.ai использует продвинутый ИИ для определения продуктов и подсчета питательных веществ по фотографии. Достигайте своих целей по здоровью с точностью и легкостью.',
      appStore: 'App Store',
      appStoreSmall: 'Скачать в',
      googlePlay: 'Google Play',
      googlePlaySmall: 'Доступно в'
    },
    features: {
      title: 'Ключевые возможности',
      subtitle: 'Узнайте, почему 1cal.ai — самый умный способ отслеживать свое питание',
      items: [
        {
          title: 'ИИ распознавание фото',
          description: 'Сделайте фото вашей еды, и наш ИИ мгновенно определит калории, белки, жиры и углеводы.'
        },
        {
          title: 'Отслеживание питания',
          description: 'Контролируйте ежедневное потребление калорий, белков, жиров и углеводов с красивой визуализацией.'
        },
        {
          title: 'Светлая и темная темы',
          description: 'Наслаждайтесь комфортным использованием с настраиваемыми светлой и темной темами для любых условий.'
        },
        {
          title: 'Поддержка разных языков',
          description: 'Используйте приложение на предпочитаемом языке с поддержкой русского, английского и других.'
        },
        {
          title: 'История приемов пищи',
          description: 'Отслеживайте свои пищевые привычки со временем с помощью детальной истории и аналитики.'
        },
        {
          title: 'Установка целей',
          description: 'Устанавливайте персональные цели по питанию и отслеживайте свой прогресс с интуитивной визуализацией.'
        }
      ]
    },
    howItWorks: {
      title: 'Как это работает',
      subtitle: 'Отслеживайте свое питание в три простых шага',
      steps: [
        {
          title: 'Сделайте фото',
          description: 'Просто сфотографируйте свою еду с помощью камеры приложения.'
        },
        {
          title: 'ИИ анализ',
          description: 'Наш продвинутый ИИ определяет еду и рассчитывает пищевую ценность.'
        },
        {
          title: 'Отслеживайте прогресс',
          description: 'Контролируйте свой ежедневный рацион и прогресс к цели по питанию.'
        }
      ]
    },
    showcase: {
      title: 'Демонстрация приложения',
      subtitle: 'Посмотрите, как 1cal.ai упрощает отслеживание питания'
    },
    testimonials: {
      title: 'Отзывы пользователей',
      subtitle: 'Присоединяйтесь к тысячам довольных пользователей, изменивших свои привычки питания'
    },
    pricing: {
      title: 'Простые тарифы',
      subtitle: 'Выберите план, который подходит вашим потребностям',
      chooseYourPlan: 'Выберите Ваш Тариф',
      monthly: 'Ежемесячно',
      annual: 'Годовой',
      free: 'Бесплатно',
      premium: 'Премиум',
      perMonth: '/месяц',
      perYear: '/год',
      popular: 'Популярный',
      discount: 'Скидка 63%',
      downloadFree: 'Скачать бесплатно',
      getPremium: 'Получить Премиум',
      monthlySubscribe: 'Оформить ежемесячную подписку',
      annualSubscribe: 'Оформить годовую подписку',
      onlyPerMonth: 'Всего {{price}}/месяц',
      freeTrial: 'Включает 3-дневный бесплатный пробный период',
      description: 'Получите безлимитный доступ к ИИ распознаванию продуктов, детальному отслеживанию питания и персонализированным рекомендациям для достижения ваших целей.',
      disclaimer: 'Цены указаны в USD. Подписываясь, вы соглашаетесь с нашими',
      refundInfo: 'Для получения дополнительной информации о политике возврата, пожалуйста, посетите нашу',
      features: {
        basicRecognition: 'Базовое распознавание еды',
        advancedRecognition: 'Продвинутое ИИ распознавание еды',
        calorieTracking: 'Подсчет калорий',
        detailedTracking: 'Детальное отслеживание питания',
        dailySummary: 'Ежедневное резюме по питанию',
        unlimitedLogs: 'Неограниченные записи приемов пищи',
        limitedLogs: '5 записей приемов пищи в день',
        reports: 'Еженедельные и ежемесячные отчеты',
        insights: 'Расширенная аналитика питания',
        personalizedInsights: 'Персонализированная аналитика питания',
        recommendations: 'Рекомендации по питанию',
        smartRecommendations: 'Умные рекомендации по питанию'
      }
    },
    download: {
      title: 'Скачайте 1cal.ai сегодня',
      description: 'Начните свой путь к лучшему питанию с нашим приложением для отслеживания калорий на базе ИИ. Доступно на iOS и Android.'
    },
    faq: {
      title: 'Часто задаваемые вопросы',
      subtitle: 'Найдите ответы на распространенные вопросы о 1cal.ai',
      items: [
        {
          question: 'Насколько точно ИИ распознает еду?',
          answer: 'Наша технология распознавания еды на базе ИИ работает на современных моделях машинного обучения и имеет точность более 95% для распространенных продуктов. Система постоянно улучшается по мере использования приложения пользователями.'
        },
        {
          question: 'Какие языки поддерживаются?',
          answer: '1cal.ai в настоящее время поддерживает русский, английский, испанский, французский, немецкий, китайский, японский и корейский. Мы постоянно работаем над добавлением новых языков, чтобы сделать наше приложение доступным для пользователей по всему миру.'
        },
        {
          question: 'Могу ли я отслеживать собственные блюда?',
          answer: 'Да! Помимо распознавания с помощью ИИ, вы можете вручную добавлять собственные блюда и сохранять их для использования в будущем. Это особенно полезно для домашних рецептов или уникальных блюд.'
        },
        {
          question: 'Как отменить премиум-подписку?',
          answer: 'Вы можете отменить премиум-подписку в любое время через настройки аккаунта в приложении или через управление подписками в вашем магазине приложений. Отмена вступит в силу по окончании текущего платежного периода.'
        }
      ]
    },
    footer: {
      description: 'Приложение для отслеживания калорий на базе ИИ, которое делает контроль питания простым и точным.',
      quickLinks: 'Быстрые ссылки',
      support: 'Поддержка',
      helpCenter: 'Центр помощи',
      privacyPolicy: 'Политика конфиденциальности',
      termsOfService: 'Условия использования',
      contact: 'Связаться с нами',
      stayUpdated: 'Будьте в курсе',
      newsletterText: 'Подпишитесь на нашу рассылку для получения последних обновлений и новостей.',
      subscribe: 'Подписаться',
      emailPlaceholder: 'Ваш Email',
      copyright: '© 2025 1cal.ai. Все права защищены.',
      privacy: 'Политика конфиденциальности',
      terms: 'Условия использования',
      subscription: 'Условия подписки',
      refund: 'Политика возврата',
      pricing: 'Тарифы',
      rights: 'Все права защищены.',
      deleteAccount: 'Если Вы хотите удалить свой аккаунт, обратитесь по email'
    },
    comingSoon: {
      appStore: {
        title: 'App Store Скоро',
        description1: 'Наше iOS-приложение в настоящее время находится в разработке и скоро будет доступно в App Store. Мы усердно работаем, чтобы обеспечить наилучший опыт отслеживания калорий для всех пользователей.',
        description2: 'Пока наше приложение доступно в Google Play. Вы также можете подписаться на нашу рассылку, чтобы получить уведомление о запуске iOS-версии.'
      },
      googlePlay: {
        title: 'Google Play Скоро',
        description1: 'Наше Android-приложение в настоящее время находится в разработке и скоро будет доступно в Google Play Store. Мы усердно работаем, чтобы обеспечить наилучший опыт отслеживания калорий для всех пользователей.',
        description2: 'Пока наше приложение доступно в App Store. Вы также можете подписаться на нашу рассылку, чтобы получить уведомление о запуске Android-версии.'
      },
      backToHome: 'Вернуться на главную'
    }
  },
  fr: {
    nav: {
      features: 'Fonctionnalités',
      howItWorks: 'Comment ça marche',
      pricing: 'Tarifs',
      download: 'Télécharger'
    },
    header: {
      features: 'Fonctionnalités',
      howItWorks: 'Comment ça marche',
      testimonials: 'Témoignages',
      pricing: 'Tarifs',
      download: 'Télécharger'
    },
    hero: {
      title: 'Suivez vos calories avec la reconnaissance photo IA',
      description: '1cal.ai utilise l\'IA avancée pour identifier les aliments et suivre votre nutrition à partir de photos. Atteignez vos objectifs de santé avec précision et facilité.',
      appStore: 'App Store',
      appStoreSmall: 'Télécharger sur',
      googlePlay: 'Google Play',
      googlePlaySmall: 'DISPONIBLE SUR'
    },
    features: {
      title: 'Fonctionnalités clés',
      subtitle: 'Découvrez pourquoi 1cal.ai est la façon la plus intelligente de suivre votre nutrition',
      items: [
        {
          title: 'Reconnaissance photo par IA',
          description: 'Prenez une photo de votre repas et notre IA identifie instantanément les calories, protéines, lipides et glucides.'
        },
        {
          title: 'Suivi nutritionnel',
          description: 'Surveillez votre apport quotidien en calories, protéines, lipides et glucides avec de belles visualisations.'
        },
        {
          title: 'Thèmes clair et sombre',
          description: 'Profitez d\'une expérience confortable avec des thèmes personnalisables pour tout environnement.'
        },
        {
          title: 'Support multilingue',
          description: 'Utilisez l\'application dans votre langue préférée avec la prise en charge du français, anglais et plus encore.'
        },
        {
          title: 'Historique des repas',
          description: 'Suivez vos habitudes alimentaires au fil du temps avec un historique détaillé et des analyses.'
        },
        {
          title: 'Définition d\'objectifs',
          description: 'Définissez des objectifs nutritionnels personnalisés et suivez vos progrès avec des visualisations intuitives.'
        }
      ]
    },
    howItWorks: {
      title: 'Comment ça marche',
      subtitle: 'Suivez votre nutrition en trois étapes simples',
      steps: [
        {
          title: 'Prenez une photo',
          description: 'Prenez simplement une photo de votre repas avec l\'appareil photo de l\'application.'
        },
        {
          title: 'Analyse par IA',
          description: 'Notre IA avancée identifie les aliments et calcule les valeurs nutritionnelles.'
        },
        {
          title: 'Suivez vos progrès',
          description: 'Surveillez votre apport quotidien et vos progrès vers vos objectifs nutritionnels.'
        }
      ]
    },
    showcase: {
      title: 'Aperçu de l\'application',
      subtitle: 'Découvrez comment 1cal.ai simplifie le suivi nutritionnel'
    },
    testimonials: {
      title: 'Ce que disent nos utilisateurs',
      subtitle: 'Rejoignez des milliers d\'utilisateurs satisfaits qui ont transformé leurs habitudes alimentaires'
    },
    pricing: {
      title: 'Tarification simple',
      subtitle: 'Choisissez le forfait qui répond à vos besoins',
      chooseYourPlan: 'Choisissez Votre Forfait',
      monthly: 'Mensuel',
      annual: 'Annuel',
      free: 'Gratuit',
      premium: 'Premium',
      perMonth: '/mois',
      perYear: '/an',
      popular: 'Populaire',
      discount: '63% de réduction',
      downloadFree: 'Télécharger gratuitement',
      getPremium: 'Obtenir Premium',
      monthlySubscribe: "S'abonner mensuellement",
      annualSubscribe: "S'abonner annuellement",
      onlyPerMonth: 'Seulement {{price}}/mois',
      freeTrial: 'Inclut un essai gratuit de 3 jours',
      description: "Obtenez un accès illimité à la reconnaissance alimentaire par IA, au suivi nutritionnel détaillé et aux informations personnalisées pour vous aider à atteindre vos objectifs de santé.",
      disclaimer: 'Les prix sont en USD. En vous abonnant, vous acceptez nos',
      refundInfo: "Pour plus d'informations sur notre politique de remboursement, veuillez consulter notre",
      features: {
        basicRecognition: 'Reconnaissance alimentaire de base',
        advancedRecognition: 'Reconnaissance alimentaire IA avancée',
        calorieTracking: 'Suivi des calories',
        detailedTracking: 'Suivi nutritionnel détaillé',
        dailySummary: 'Résumé nutritionnel quotidien',
        unlimitedLogs: 'Journaux de repas illimités',
        limitedLogs: '5 journaux de repas par jour',
        reports: 'Rapports hebdomadaires et mensuels',
        insights: 'Analyses nutritionnelles avancées',
        personalizedInsights: 'Analyses nutritionnelles personnalisées',
        recommendations: 'Recommandations de repas',
        smartRecommendations: 'Recommandations de repas intelligentes'
      }
    },
    download: {
      title: 'Téléchargez 1cal.ai aujourd\'hui',
      description: 'Commencez votre voyage vers une meilleure nutrition avec notre application de suivi des calories basée sur l\'IA. Disponible sur iOS et Android.'
    },
    faq: {
      title: 'Questions fréquemment posées',
      subtitle: 'Trouvez des réponses aux questions courantes sur 1cal.ai',
      items: [
        {
          question: 'Quelle est la précision de la reconnaissance alimentaire par IA?',
          answer: 'Notre technologie de reconnaissance alimentaire par IA est alimentée par des modèles d\'apprentissage automatique de pointe et a un taux de précision de plus de 95% pour les aliments courants. Le système s\'améliore continuellement à mesure que plus d\'utilisateurs utilisent l\'application.'
        },
        {
          question: 'Quelles langues sont prises en charge?',
          answer: '1cal.ai prend actuellement en charge le français, l\'anglais, l\'espagnol, le russe, l\'allemand, le chinois, le japonais et le coréen. Nous travaillons constamment à l\'ajout de nouvelles langues pour rendre notre application accessible aux utilisateurs du monde entier.'
        },
        {
          question: 'Puis-je suivre des repas personnalisés?',
          answer: 'Oui! En plus de la reconnaissance par IA, vous pouvez ajouter manuellement des repas personnalisés et les enregistrer pour une utilisation future. C\'est particulièrement utile pour les recettes maison ou les plats uniques.'
        },
        {
          question: 'Comment puis-je annuler mon abonnement premium?',
          answer: 'Vous pouvez annuler votre abonnement premium à tout moment via les paramètres de votre compte dans l\'application ou via la gestion des abonnements de votre app store. L\'annulation prendra effet à la fin de votre période de facturation actuelle.'
        }
      ]
    },
    footer: {
      description: 'Application de suivi des calories basée sur l\'IA qui rend le suivi nutritionnel simple et précis.',
      quickLinks: 'Liens rapides',
      support: 'Support',
      helpCenter: 'Centre d\'aide',
      privacy: 'Politique de confidentialité',
      terms: 'Conditions d\'utilisation',
      subscription: 'Conditions d\'abonnement',
      refund: 'Politique de remboursement',
      pricing: 'Tarifs',
      rights: 'Tous droits réservés.',
      deleteAccount: 'Si vous souhaitez supprimer votre compte, veuillez nous contacter par email'
    },
    comingSoon: {
      appStore: {
        title: 'App Store Bientôt Disponible',
        description1: 'Notre application iOS est actuellement en cours de développement et sera bientôt disponible sur l\'App Store. Nous travaillons dur pour offrir la meilleure expérience de suivi des calories à tous les utilisateurs.',
        description2: 'Pour l\'instant, notre application est disponible sur Google Play. Vous pouvez également vous abonner à notre newsletter pour être informé du lancement de la version iOS.'
      },
      googlePlay: {
        title: 'Google Play Bientôt Disponible',
        description1: 'Notre application Android est actuellement en cours de développement et sera bientôt disponible sur Google Play Store. Nous travaillons dur pour offrir la meilleure expérience de suivi des calories à tous les utilisateurs.',
        description2: 'Pour l\'instant, notre application est disponible sur l\'App Store. Vous pouvez également vous abonner à notre newsletter pour être informé du lancement de la version Android.'
      },
      backToHome: 'Retour à l\'Accueil'
    }
  },
  es: {
    nav: {
      features: 'Características',
      howItWorks: 'Cómo funciona',
      pricing: 'Precios',
      download: 'Descargar'
    },
    header: {
      features: 'Características',
      howItWorks: 'Cómo funciona',
      testimonials: 'Testimonios',
      pricing: 'Precios',
      download: 'Descargar'
    },
    hero: {
      title: 'Controla tus calorías con reconocimiento fotográfico impulsado por IA',
      description: '1cal.ai utiliza IA avanzada para identificar alimentos y seguir tu nutrición a partir de fotos. Logra tus objetivos de salud con precisión y facilidad.',
      appStore: 'App Store',
      appStoreSmall: 'Descargar en el',
      googlePlay: 'Google Play',
      googlePlaySmall: 'CONSÍGUELO EN'
    },
    features: {
      title: 'Características clave',
      subtitle: 'Descubre por qué 1cal.ai es la forma más inteligente de controlar tu nutrición',
      items: [
        {
          title: 'Reconocimiento fotográfico por IA',
          description: 'Toma una foto de tu comida y nuestra IA identifica instantáneamente calorías, proteínas, grasas y carbohidratos.'
        },
        {
          title: 'Seguimiento nutricional',
          description: 'Monitorea tu ingesta diaria de calorías, proteínas, grasas y carbohidratos con hermosas visualizaciones.'
        },
        {
          title: 'Temas claro y oscuro',
          description: 'Disfruta de una experiencia cómoda con temas personalizables para cualquier entorno.'
        },
        {
          title: 'Soporte multilingüe',
          description: 'Usa la aplicación en tu idioma preferido con soporte para español, inglés y más.'
        },
        {
          title: 'Historial de comidas',
          description: 'Sigue tus patrones alimenticios a lo largo del tiempo con un historial detallado y análisis.'
        },
        {
          title: 'Establecimiento de objetivos',
          description: 'Establece objetivos nutricionales personalizados y sigue tu progreso con visualizaciones intuitivas.'
        }
      ]
    },
    howItWorks: {
      title: 'Cómo funciona',
      subtitle: 'Controla tu nutrición en tres simples pasos',
      steps: [
        {
          title: 'Toma una foto',
          description: 'Simplemente toma una foto de tu comida usando la cámara de la aplicación.'
        },
        {
          title: 'Análisis por IA',
          description: 'Nuestra IA avanzada identifica la comida y calcula los valores nutricionales.'
        },
        {
          title: 'Sigue tu progreso',
          description: 'Monitorea tu ingesta diaria y el progreso hacia tus objetivos nutricionales.'
        }
      ]
    },
    showcase: {
      title: 'Demostración de la aplicación',
      subtitle: 'Mira cómo 1cal.ai hace que el seguimiento nutricional sea sencillo'
    },
    testimonials: {
      title: 'Lo que dicen nuestros usuarios',
      subtitle: 'Únete a miles de usuarios satisfechos que han transformado sus hábitos alimenticios'
    },
    pricing: {
      title: 'Precios simples',
      subtitle: 'Elige el plan que se adapte a tus necesidades',
      chooseYourPlan: 'Elige Tu Plan',
      monthly: 'Mensual',
      annual: 'Anual',
      free: 'Gratis',
      premium: 'Premium',
      perMonth: '/mes',
      perYear: '/año',
      popular: 'Popular',
      discount: '63% de descuento',
      downloadFree: 'Descargar gratis',
      getPremium: 'Obtener Premium',
      monthlySubscribe: 'Suscribirse mensualmente',
      annualSubscribe: 'Suscribirse anualmente',
      onlyPerMonth: 'Solo {{price}}/mes',
      freeTrial: 'Incluye prueba gratuita de 3 días',
      description: 'Obtén acceso ilimitado al reconocimiento de alimentos con IA, seguimiento nutricional detallado e información personalizada para ayudarte a alcanzar tus objetivos de salud.',
      disclaimer: 'Los precios están en USD. Al suscribirte, aceptas nuestros',
      refundInfo: 'Para más información sobre nuestra política de reembolso, visita nuestra',
      features: {
        basicRecognition: 'Reconocimiento básico de alimentos',
        advancedRecognition: 'Reconocimiento avanzado de alimentos por IA',
        calorieTracking: 'Seguimiento de calorías',
        detailedTracking: 'Seguimiento nutricional detallado',
        dailySummary: 'Resumen nutricional diario',
        unlimitedLogs: 'Registros de comidas ilimitados',
        limitedLogs: '5 registros de comidas por día',
        reports: 'Informes semanales y mensuales',
        insights: 'Análisis nutricionales avanzados',
        personalizedInsights: 'Análisis nutricionales personalizados',
        recommendations: 'Recomendaciones de comidas',
        smartRecommendations: 'Recomendaciones inteligentes de comidas'
      }
    },
    download: {
      title: 'Descarga 1cal.ai hoy',
      description: 'Comienza tu viaje hacia una mejor nutrición con nuestra aplicación de seguimiento de calorías impulsada por IA. Disponible en iOS y Android.'
    },
    faq: {
      title: 'Preguntas frecuentes',
      subtitle: 'Encuentra respuestas a preguntas comunes sobre 1cal.ai',
      items: [
        {
          question: '¿Qué tan preciso es el reconocimiento de alimentos por IA?',
          answer: 'Nuestra tecnología de reconocimiento de alimentos por IA está impulsada por modelos de aprendizaje automático de última generación y tiene una tasa de precisión de más del 95% para alimentos comunes. El sistema mejora continuamente a medida que más usuarios utilizan la aplicación.'
        },
        {
          question: '¿Qué idiomas se admiten?',
          answer: '1cal.ai actualmente admite español, inglés, ruso, francés, alemán, chino, japonés y coreano. Trabajamos constantemente para agregar más idiomas y hacer que nuestra aplicación sea accesible para usuarios de todo el mundo.'
        },
        {
          question: '¿Puedo seguir comidas personalizadas?',
          answer: '¡Sí! Además del reconocimiento por IA, puedes agregar manualmente comidas personalizadas y guardarlas para uso futuro. Esto es especialmente útil para recetas caseras o platos únicos.'
        },
        {
          question: '¿Cómo cancelo mi suscripción premium?',
          answer: 'Puedes cancelar tu suscripción premium en cualquier momento a través de la configuración de tu cuenta en la aplicación o a través de la gestión de suscripciones de tu tienda de aplicaciones. La cancelación entrará en vigor al final de tu período de facturación actual.'
        }
      ]
    },
    footer: {
      description: 'Aplicación de seguimiento de calorías impulsada por IA que hace que el monitoreo nutricional sea simple y preciso.',
      quickLinks: 'Enlaces rápidos',
      support: 'Soporte',
      helpCenter: 'Centro de ayuda',
      privacy: 'Política de privacidad',
      terms: 'Términos de servicio',
      subscription: 'Términos de suscripción',
      refund: 'Política de reembolso',
      pricing: 'Precios',
      rights: 'Todos los derechos reservados.',
      deleteAccount: 'Si desea eliminar su cuenta, contáctenos por email'
    },
    comingSoon: {
      appStore: {
        title: 'App Store Próximamente',
        description1: 'Nuestra aplicación iOS está actualmente en desarrollo y estará disponible en App Store próximamente. Estamos trabajando duro para proporcionar la mejor experiencia de seguimiento de calorías para todos los usuarios.',
        description2: 'Por ahora, nuestra aplicación está disponible en Google Play. También puedes suscribirte a nuestro boletín para recibir una notificación cuando la versión iOS se lance.'
      },
      googlePlay: {
        title: 'Google Play Próximamente',
        description1: 'Nuestra aplicación Android está actualmente en desarrollo y estará disponible en Google Play Store próximamente. Estamos trabajando duro para proporcionar la mejor experiencia de seguimiento de calorías para todos los usuarios.',
        description2: 'Por ahora, nuestra aplicación está disponible en App Store. También puedes suscribirte a nuestro boletín para recibir una notificación cuando la versión Android se lance.'
      },
      backToHome: 'Volver al Inicio'
    }
  },
  de: {
    nav: {
      features: 'Funktionen',
      howItWorks: 'Wie es funktioniert',
      pricing: 'Preise',
      download: 'Herunterladen'
    },
    header: {
      features: 'Funktionen',
      howItWorks: 'Wie es funktioniert',
      testimonials: 'Testimonials',
      pricing: 'Preise',
      download: 'Herunterladen'
    },
    hero: {
      title: 'Kalorien mit KI-gestützter Fotoerkennung verfolgen',
      description: '1cal.ai nutzt fortschrittliche KI, um Lebensmittel zu identifizieren und Ihre Ernährung anhand von Fotos zu verfolgen. Erreichen Sie Ihre Gesundheitsziele mit Präzision und Leichtigkeit.',
      appStore: 'App Store',
      appStoreSmall: 'Laden im',
      googlePlay: 'Google Play',
      googlePlaySmall: 'JETZT BEI'
    },
    features: {
      title: 'Hauptfunktionen',
      subtitle: 'Entdecken Sie, warum 1cal.ai die intelligenteste Art ist, Ihre Ernährung zu verfolgen',
      items: [
        {
          title: 'KI-Fotoerkennung',
          description: 'Machen Sie ein Foto Ihres Essens und unsere KI identifiziert sofort Kalorien, Eiweiß, Fette und Kohlenhydrate.'
        },
        {
          title: 'Ernährungsverfolgung',
          description: 'Überwachen Sie Ihre tägliche Aufnahme von Kalorien, Eiweiß, Fetten und Kohlenhydraten mit schönen Visualisierungen.'
        },
        {
          title: 'Helle & dunkle Themen',
          description: 'Genießen Sie eine komfortable Erfahrung mit anpassbaren hellen und dunklen Designs für jede Umgebung.'
        },
        {
          title: 'Mehrsprachige Unterstützung',
          description: 'Verwenden Sie die App in Ihrer bevorzugten Sprache mit Unterstützung für Deutsch, Englisch und mehr.'
        },
        {
          title: 'Mahlzeitenhistorie',
          description: 'Verfolgen Sie Ihre Essgewohnheiten im Laufe der Zeit mit detaillierter Historie und Analysen.'
        },
        {
          title: 'Zielsetzung',
          description: 'Setzen Sie persönliche Ernährungsziele und verfolgen Sie Ihren Fortschritt mit intuitiven Visualisierungen.'
        }
      ]
    },
    howItWorks: {
      title: 'Wie es funktioniert',
      subtitle: 'Verfolgen Sie Ihre Ernährung in drei einfachen Schritten',
      steps: [
        {
          title: 'Foto machen',
          description: 'Machen Sie einfach ein Foto Ihrer Mahlzeit mit der Kamera der App.'
        },
        {
          title: 'KI-Analyse',
          description: 'Unsere fortschrittliche KI identifiziert die Lebensmittel und berechnet die Nährwerte.'
        },
        {
          title: 'Fortschritt verfolgen',
          description: 'Überwachen Sie Ihre tägliche Aufnahme und den Fortschritt in Richtung Ihrer Ernährungsziele.'
        }
      ]
    },
    showcase: {
      title: 'App-Präsentation',
      subtitle: 'Sehen Sie, wie 1cal.ai die Ernährungsverfolgung mühelos macht'
    },
    testimonials: {
      title: 'Was unsere Nutzer sagen',
      subtitle: 'Schließen Sie sich Tausenden zufriedener Nutzer an, die ihre Ernährungsgewohnheiten transformiert haben'
    },
    pricing: {
      title: 'Einfache Preise',
      subtitle: 'Wählen Sie den Plan, der zu Ihren Bedürfnissen passt',
      chooseYourPlan: 'Wählen Sie Ihren Tarif',
      monthly: 'Monatlich',
      annual: 'Jährlich',
      free: 'Kostenlos',
      premium: 'Premium',
      perMonth: '/Monat',
      perYear: '/Jahr',
      popular: 'Beliebt',
      discount: '63% Rabatt',
      downloadFree: 'Kostenlos herunterladen',
      getPremium: 'Premium erhalten',
      monthlySubscribe: 'Monatlich abonnieren',
      annualSubscribe: 'Jährlich abonnieren',
      onlyPerMonth: 'Nur {{price}}/Monat',
      freeTrial: 'Beinhaltet 3-tägige kostenlose Testversion',
      description: 'Erhalten Sie unbegrenzten Zugriff auf KI-Lebensmittelerkennung, detaillierte Ernährungsverfolgung und personalisierte Einblicke, um Ihre Gesundheitsziele zu erreichen.',
      disclaimer: 'Preise sind in USD angegeben. Mit dem Abonnieren stimmen Sie unseren',
      refundInfo: 'Für weitere Informationen zu unserer Rückerstattungsrichtlinie besuchen Sie bitte unsere',
      features: {
        basicRecognition: 'Grundlegende Lebensmittelerkennung',
        advancedRecognition: 'Fortschrittliche KI-Lebensmittelerkennung',
        calorieTracking: 'Kalorientracking',
        detailedTracking: 'Detaillierte Ernährungsverfolgung',
        dailySummary: 'Tägliche Ernährungszusammenfassung',
        unlimitedLogs: 'Unbegrenzte Mahlzeitenprotokolle',
        limitedLogs: '5 Mahlzeitenprotokolle pro Tag',
        reports: 'Wöchentliche & monatliche Berichte',
        insights: 'Erweiterte Ernährungseinblicke',
        personalizedInsights: 'Personalisierte Ernährungseinblicke',
        recommendations: 'Mahlzeitenempfehlungen',
        smartRecommendations: 'Intelligente Mahlzeitenempfehlungen'
      }
    },
    download: {
      title: 'Laden Sie 1cal.ai heute herunter',
      description: 'Beginnen Sie Ihre Reise zu einer besseren Ernährung mit unserer KI-gestützten Kalorien-Tracking-App. Verfügbar für iOS und Android.'
    },
    faq: {
      title: 'Häufig gestellte Fragen',
      subtitle: 'Finden Sie Antworten auf häufige Fragen zu 1cal.ai',
      items: [
        {
          question: 'Wie genau ist die KI-Lebensmittelerkennung?',
          answer: 'Unsere KI-Lebensmittelerkennungstechnologie wird von hochmodernen maschinellen Lernmodellen angetrieben und hat eine Genauigkeitsrate von über 95% für gängige Lebensmittel. Das System verbessert sich kontinuierlich, wenn mehr Benutzer die App nutzen.'
        },
        {
          question: 'Welche Sprachen werden unterstützt?',
          answer: '1cal.ai unterstützt derzeit Deutsch, Englisch, Russisch, Spanisch, Französisch, Chinesisch, Japanisch und Koreanisch. Wir arbeiten ständig daran, weitere Sprachen hinzuzufügen, um unsere App für Benutzer weltweit zugänglich zu machen.'
        },
        {
          question: 'Kann ich benutzerdefinierte Mahlzeiten verfolgen?',
          answer: 'Ja! Zusätzlich zur KI-Erkennung können Sie benutzerdefinierte Mahlzeiten manuell hinzufügen und für die zukünftige Verwendung speichern. Dies ist besonders nützlich für hausgemachte Rezepte oder einzigartige Gerichte.'
        },
        {
          question: 'Wie kündige ich mein Premium-Abonnement?',
          answer: 'Sie können Ihr Premium-Abonnement jederzeit über die Kontoeinstellungen in der App oder über die Abonnementverwaltung Ihres App-Stores kündigen. Die Kündigung wird am Ende Ihrer aktuellen Abrechnungsperiode wirksam.'
        }
      ]
    },
    footer: {
      description: 'KI-gestützte Kalorien-Tracking-App, die die Ernährungsüberwachung einfach und präzise macht.',
      quickLinks: 'Schnelllinks',
      support: 'Support',
      helpCenter: 'Hilfezentrum',
      privacy: 'Datenschutzrichtlinie',
      terms: 'Nutzungsbedingungen',
      subscription: 'Abonnementbedingungen',
      refund: 'Rückerstattungsrichtlinie',
      pricing: 'Preise',
      rights: 'Alle Rechte vorbehalten.',
      deleteAccount: 'Wenn Sie Ihr Konto löschen möchten, kontaktieren Sie uns bitte per E-Mail'
    },
    comingSoon: {
      appStore: {
        title: 'App Store Kommt Bald',
        description1: 'Unsere iOS-Anwendung befindet sich derzeit in der Entwicklung und wird bald im App Store verfügbar sein. Wir arbeiten hart daran, allen Nutzern die beste Kalorienverfolgungserfahrung zu bieten.',
        description2: 'Vorerst ist unsere App bei Google Play verfügbar. Sie können auch unseren Newsletter abonnieren, um benachrichtigt zu werden, wenn die iOS-Version veröffentlicht wird.'
      },
      googlePlay: {
        title: 'Google Play Kommt Bald',
        description1: 'Unsere Android-Anwendung befindet sich derzeit in der Entwicklung und wird bald im Google Play Store verfügbar sein. Wir arbeiten hart daran, allen Nutzern die beste Kalorienverfolgungserfahrung zu bieten.',
        description2: 'Vorerst ist unsere App im App Store verfügbar. Sie können auch unseren Newsletter abonnieren, um benachrichtigt zu werden, wenn die Android-Version veröffentlicht wird.'
      },
      backToHome: 'Zurück zur Startseite'
    }
  }
}; 